import { PhoneNumberProps } from './PhoneNumberProps'

import { preparePhoneNumberToHref } from '../../../common/helpers/helpers'
import AppIcon from '../../atoms/AppIcon/AppIcon'
import AppLink from '../../atoms/AppLink/AppLink'
import { APP_FONT_SIZE } from '../../atoms/AtomsGlobalProps'
import { ReactComponent as PhoneIcon } from '../../../icons/svg/phone-icon.svg'
import Span from '../../atoms/Span/Span'


import './PhoneNumberStyles.scss'


const PhoneNumber = (props: PhoneNumberProps) => {
   if(!props.isPhoneAvailable){
      return null
   }

   return (
      <div className='page-phone-wrapper-outer'>
         <h2 className='page-phone-question-text'>Masz pytania?</h2>
         <AppLink className='page-phone-wrapper-inner' href={preparePhoneNumberToHref(props.phoneNumber)}>
            <AppIcon icon={PhoneIcon} className='page-phone-wrapper-phone-icon' decorative />
            <Span className='page-phone-wrapper-phone-number' size={APP_FONT_SIZE.EXTRA_SMALL} bold>
               {props.phoneNumber}
            </Span>
         </AppLink>
      </div>
   )
}

export default PhoneNumber